
































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { IMap, IBaseMapProvider, IMeasurer } from "./types";
import Map from "./Map";

@Component({})
export default class ControlsUI extends Vue {
  @Prop({
    default: () => { return false; }
  }) smallMobile: boolean;
  @Prop({
    default: () => { return 'getInfo'; }
  }) action: string;
  @Prop({
    default: () => {
        return {
          name: 'distance', // distance | area2 | coordinate
          icon: 'straighten', // straighten | flip_to_front | location_on
          unit: 'metric',
          crs: 'WGS84'
        }
      }
  }) measurer: IMeasurer;
  @Prop({
    default: () => { return 'gistda.thaichote'; }
  }) basemap: string;

  // use getter does not update UI when value change
  // such as BaseMaps so we update it as as like a prop
  // when this component is mounted();
  BaseMaps: IBaseMapProvider[] = null;
  BaseMapListIsOpen: boolean =  false;
  hasAlreadyCreatedBasemapView: boolean = false;
  $map: Map;
  
  get map() : IMap {
    return this.$map ? this.$map.map : null;
  };
  /*get BaseMaps() {
    return this.map.BaseMaps || null;
  };*/

  ContainerHeight : string = 'calc(100% - 60px)'; //'735px';
  setContainerHeight() {
    let coord = <HTMLElement>this.$el.parentElement.querySelector('.scale-coordinates');
    if (coord) {
      this.ContainerHeight = 'calc(100% - ' + (coord.offsetHeight + 3) + 'px)';
    } else {
      this.ContainerHeight = '100%';
    }
    /*if (!this.BaseMapListIsOpen || !this.$map) {
      this.ContainerHeight = '310px';
    } else {
      let nProviders = this.BaseMaps.length;
      let nMaps = 0;
      this.BaseMaps.forEach((provider) => {
        nMaps += provider.Maps.length;
      });
      let h = nProviders * 25 + (nProviders - 1) * 4 + 50 * nMaps;
      this.ContainerHeight = h; //this.$map.map.HasGoogleMap ? 735 : 499;
    }*/
  }

  mounted() {
    if (this.$parent) {
      this.$map = <Map> this.$parent;
      this.BaseMaps = this.$map.map.BaseMaps;
      this.setContainerHeight();
    }
  };

  setMapAction(action, params) {
    this.$emit('click', {
      name: action,
      params: params || {}
    });
  };

  toggleBaseMapList() {
    this.BaseMapListIsOpen = !this.BaseMapListIsOpen;
    this.setContainerHeight(); //IMPORTANT: do this after above
    let self = this;
    setTimeout(() => {
      if (self.BaseMaps && self.BaseMapListIsOpen) {
        if (!self.hasAlreadyCreatedBasemapView) {
          let map = self.$map.map.NativeMap;
          let view = map.getView();
          let center = view.getCenter();
          let zoom = view.getZoom();
          let rotate = view.getRotation();
          self.$map.createBaseMapViews(center, zoom, rotate);
          self.hasAlreadyCreatedBasemapView = true;
        }
        setTimeout(() => {
          self.$map.refreshBaseMapLists();
        }, 10);
      }
    }, 100);
    this.$emit('openbasemap', this.BaseMapListIsOpen);
  }
}
